import Vue from 'vue'
import loadingComponent from '../components/loadings.vue'

const LoadingConstructor = Vue.extend(loadingComponent)

const instance = new LoadingConstructor({
    el: document.createElement('div')
})

instance.show = false // 默认隐藏
const loadings = {
    show() { // 显示方法
        instance.show = true
        document.body.appendChild(instance.$el)
    },
    hide() { // 隐藏方法
        instance.show = false
    }
}

export default {
    install() {
        if (!Vue.$loadings) {
            Vue.$loadings = loadings
        }
        Vue.mixin({
            created() {
                this.$loadings = Vue.$loadings
            }
        })
    }
}
